<template>
  <vx-card class="campaign-summary" :noShadow="true">
    <div class="vs-row header-divider">
      <vs-divider />
      <p class="font-bold mb-3 custom-type-style">
        {{ $t("Campaign Objective") }}:
      </p>

      <div class="flex custom-objective-style">
        <div class="flex-initial mr-4">
          <img class="inline-block align-middle" width="24" height="24" :src="selectedObjective.image" alt="objective-img"/>
        </div>
        <div class="flex-initial">
          <span class="text-black text-sm inline-block align-middle">{{ selectedObjective.title }}</span>
        </div>
      </div>
    </div>

    <vs-divider class="custom-divider-style" />

    <div class="vs-row">
      <p class="font-bold mb-3 custom-type-style">
        {{ $t("Campaign Type") }}:
      </p>
      <div class="flex pt-1 custom-type-style">
        <div class="flex-initial mr-4">
          <img class="inline-block align-middle" width="24" height="24" :src="selectedType.image" alt="type-img" />
        </div>
        <div class="flex-initial">
          <span class="text-sm inline-block align-middle">{{ selectedType.title }}</span>
        </div>
      </div>
    </div>

    <div class="vs-row mt-4 custom-summary-button-style" v-if="!editing">
      <vs-button id="create-campaign-summary-s1-button" color="primary" type="filled" class="w-full text-sm block m-auto rounded-sm" @click="goToStep()">
        {{ $t('Edit Campaign Objective & Type') }}
      </vs-button>
    </div>
    <vs-divider class="vs-divider-custom" />
  </vx-card>
</template>

<script>
export default {
  props: ['type', 'objective', 'editing'],
  computed: {
    objectives () {
      return this.$store.getters['campaign/targetingLookups'].objectives
    },

    types () {
      return this.$store.getters['campaign/targetingLookups'].display_types
    },

    selectedObjective () {
      if (this.objectives) {
        return this.objectives.find(o => o.id === this.objective)
      }

      return  {id: 0, image: ''}
    },

    selectedType () {
      if (this.types) {
        return this.types.find(o => o.id === this.type)
      }

      return {id: 0, image: ''}
    }
  },
  methods: {
    goToStep () {
      const wizard = this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.campaignWizard

      wizard.navigateToTab(0)
    }
  }
}
</script>
